import moment from 'moment';
import styled from 'styled-components';
import { DEVICES } from 'utils/media';

import { StyledInline } from 'modules/log/LogItem/styled';
import ServiceTag, { SKINS } from 'components/ServiceTag';
import { injectIntl } from 'react-intl';

const StyledAuthor = styled(StyledInline)`
  white-space: nowrap;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 1.6rem;

  .author-wrapper {
    display: flex;
    flex-direction: column;

    @media ${DEVICES.desktop} {
      flex-direction: row;
    }

    .author {
      margin-left: 0.4rem;
    }

    .dash {
      display: none;
      margin: 0 0.4rem;

      @media ${DEVICES.desktop} {
        display: block;
      }
    }
  }
`;

const LogDate = ({ date, t }) => {
  if (!date) {
    return '';
  }

  const formatDate = moment(date);
  const today = moment();

  if (formatDate.isSame(today, 'day')) {
    return formatDate.format(t.today_time);
  }

  if (formatDate.isSame(today.subtract(1, 'days'), 'day')) {
    return formatDate.format(t.yesterday_time);
  }

  return formatDate.format(t.full_datetime);
};

const Author = ({ created_by, created_at, userType, intl, ...props }) => {
  const t = intl.messages.modules.author;
  const userTypes = {
    SHIPPER: <ServiceTag skin={SKINS.userTypeShipper} text={t.user_types.shipper} size="S" />,
    INTERNAL: <ServiceTag skin={SKINS.userTypeInternal} text={t.user_types.internal} size="S" />,
    SYSTEM: <ServiceTag skin={SKINS.userTypeSystem} text={t.user_types.system} size="S" />,
    CROSSDOCK: <ServiceTag skin={SKINS.userTypeCrossdock} text={t.user_types.crossdock} size="S" />,
    CARRIER: <ServiceTag skin={SKINS.userTypeCarrier} text={t.user_types.carrier} size="S" />,
  };

  const userTypeTag = userTypes[userType];

  return (
    <StyledAuthor {...props}>
      <div className="author-wrapper">
        {userTypeTag}
        <span className="author" data-testid="log-author">
          {created_by || t.default_author}
        </span>
        {!!created_at && (
          <span className="dash" data-testid="log-dash">
            {' '}
            -{' '}
          </span>
        )}
        <span className="date" data-testid="log-date">
          <LogDate date={created_at} t={t} />
        </span>
      </div>
    </StyledAuthor>
  );
};

export default injectIntl(Author);
